import React from "react";
import { useTranslation } from "react-i18next";
import TabsAndInputSearchBox from "@/components/SearchAndResultShared/TabsAndInputSearchBox";
import Overlay from "@/components/overlay";
import { setDigitalData } from "@/services/setDigitalData";
import MetaDataTags from "@/components/metaDataTags/MetaDataTags";

const SiteSearchPage = (props) => {
  const { t } = useTranslation();
  const {countryCode} = props;

  if(countryCode === 'us') {
    setDigitalData({gcpPageName: 'Search Results'});
  }

  return <>
    <MetaDataTags
        title={t("searchResultBrowserTitle")}
        description={t("businessDirectory.bdPageMetaDescription")}
    />
    <div className="heading isContactDirectoryLandingPageAndNotSearchOverlay-false">
      <div className="headingImageAndTextWrapper">
        <div className="headingImage isBusinessDirectoryLandingPage-false"></div>
        <div className="headingText">Dun &amp; Bradstreet Cloud durchsuchen</div>
      </div>
    </div>
    <TabsAndInputSearchBox  {...props} />
    <Overlay countryCode={countryCode} isEmailDisplay={['at','us'].includes(countryCode)} isPhoneDisplay={['de','at','ch','us'].includes(countryCode)}  
        isRecaptchaDisplay={!['de','at','ch','hu','pl','us'].includes(countryCode)}
        />
  </>;
};

export default SiteSearchPage;
